import { getCurrentLocale } from '../helpers/getCurrentLocale';

export default class NumberFormatter {
    static numberFormatter = new Intl.NumberFormat(getCurrentLocale(window.siteConfig().language ?? 'de'));

    /* TODO: add currency formatting method for shop here */

    static formattedNumber(number) {
        return this.numberFormatter.format(number);
    }
}
